export default __webpack_public_path__ + "static/img/editing.638f029.png";